import { configToast, showErrorNotification, showSuccessNotification } from '../../customHooks';
import * as actionTypes from '../actionsTypes/Types';



//EMPTYTABLE DATA
export const emptyTableData = (data,count,message) => {
    //showSuccessNotification(count ?'Login Successfully!' : 'Login Failed')
    return {
        type: actionTypes.EMPTY_TABLE_DATA,
        payload: data,
        message:message,
        pageCount:count,
    }
}

//USER ACTION
export const userAction = (type,payload) => {
    return sendToReducer(type,payload)
}

//DESIGNATION ACTION
export const designationAction = (type,payload) => {
    return sendToReducer(type,payload)
} 

//TOOLS ACTION
export const toolAction = (type,payload) => {
    return sendToReducer(type,payload)
} 

//RESPONSIBILITY ACTION
export const responsibilityAction = (type,payload) => {
    return sendToReducer(type,payload)
}
 
//TECHNOLOGY ACTION
export const technologyAction = (type,payload) => {
    return sendToReducer(type,payload)
}

//VENDOR ACTION
export const vendorAction = (type,payload) => {
    return sendToReducer(type,payload)
}

//CREATED CV ACTION
export const createdCVAction = (type,payload) => {
    return sendToReducer(type,payload)
}

// FRAMEWORK ACTION 
export const frameWorkAction = (type,payload) => {
    return sendToReducer(type,payload)
}

// IDE ACTION 
export const ideAction = (type,payload) => {
    return sendToReducer(type,payload)
}

// VERSION CONTROL ACTION 
export const versionControlAction = (type,payload) => {
    return sendToReducer(type,payload)
}

// WEBSERVICE ACTION 
export const webServicesAction = (type,payload) => {
    return sendToReducer(type,payload)
}

// OTHERSKILLS ACTION 
export const otherSkillsAction = (type,payload) => {
    return sendToReducer(type,payload)
}

// OPERATINGSYSTEMS ACTION 
export const operatingSystemsAction = (type,payload) => {
    return sendToReducer(type,payload)
}


// GOOGLE_COMPONENTS ACTION 
export const googleComponentsAction = (type,payload) => {
    return sendToReducer(type,payload)
}

// APP_SETTING ACTION 
export const appSettingsAction = (type,payload) => {
    return sendToReducer(type,payload)
}


//Project ACTION
export const projectDataStart = (userId,searchValue="",pageNo,pageSize) => {
    return {
        type: actionTypes.PROJECT_TABLE_DATA_START,
        userId:userId,
        searchValue:searchValue,
        pageNo:pageNo,
        pageSize:pageSize,
    }
} 

export const projectDataSuccess = (data,count,message) => {
   // showSuccessNotification(`${count} Projects Found`)
    return {
        type: actionTypes.PROJECT_TABLE_DATA_SUCCESS,
        payload: data,
        message:message,
        pageCount:count,
    }
}
export const projectDataFailed = (error,data) => {
    //showErrorNotification(error?.data?.message)

    return {
        type: actionTypes.PROJECT_TABLE_DATA_FAILED,
        payload: error,
        data:data,
    }
}
function sendToReducer(type,payload) {
    return {
        type: type,
        payload: payload,
    };
}
